/**
 * Custom Error class for request-iframe errors
 * Extends native Error with additional error response fields
 */
export class RequestIframeError extends Error {
  /** Error code */

  /** Request configuration */

  /** Response data (if available) */

  /** Request ID */

  constructor(error) {
    super(error.message);
    this.name = 'RequestIframeError';
    this.code = error.code;
    this.config = error.config;
    this.response = error.response;
    this.requestId = error.requestId;

    // Maintain proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RequestIframeError);
    }
  }
}